import { PLATFORM_POLICY_MRN } from "~/lib/mrn";
import { PolicyExceptionsTab } from "~/pages/shared/policy/tabs/PolicyExceptionsTab";

export function PlatformPolicyExceptionsTab() {
  return <PolicyExceptionsTab scopeMrn={PLATFORM_POLICY_MRN} />;
}
